export default __webpack_public_path__ + "media/application/assets/images/signing-instructions/TN-ed1e3435d4e3f0ff4309348b5edf2268.PNG";